import { Component, Input } from '@angular/core';
import { GameStatus } from '../../domain/game';

interface GameCollectionStatusPresentation {
  icon: string;
  tooltip: string;
  cssClass: string;
}

const GAME_COLLECTION_STATUS_PRESENTATIONS: Record<
  GameStatus,
  GameCollectionStatusPresentation
> = {
  [GameStatus.NEW]: {
    icon: 'new_releases',
    tooltip: 'New',
    cssClass: 'status-new'
  },
  [GameStatus.IN_COLLECTION]: {
    icon: 'cached',
    tooltip: 'Collection In Progress',
    cssClass: 'status-in-collection'
  },
  [GameStatus.IN_EXTENDED_COLLECTION]: {
    icon: 'cached',
    tooltip: 'Collection In Progress',
    cssClass: 'status-in-collection'
  },
  [GameStatus.QUALITY_CONTROL]: {
    icon: 'supervised_user_circle',
    tooltip: 'Collection Quality Control',
    cssClass: 'status-quality-control'
  },
  [GameStatus.COMPLETE]: {
    icon: 'check_circle',
    tooltip: 'Collection Complete',
    cssClass: 'status-complete'
  },
  [GameStatus.FAILED]: {
    icon: 'cancel',
    tooltip: 'Collection Failed',
    cssClass: 'status-failed'
  },
  [GameStatus.ABANDONED]: {
    icon: 'clear',
    tooltip: 'Collection Abandoned',
    cssClass: 'status-abandoned'
  }
};

@Component({
  selector: 'app-game-collection-status',
  templateUrl: './game-collection-status.component.html',
  styleUrls: ['./game-collection-status.component.css']
})
export class GameCollectionStatusComponent {
  @Input() status: GameStatus | null = null;

  get presentation(): GameCollectionStatusPresentation | null {
    return this.status
      ? GAME_COLLECTION_STATUS_PRESENTATIONS[this.status] ?? null
      : null;
  }
}
